
    import {Component, Prop} from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import {UserLoginAttemptDto} from "../entities/UserLoginAttemptDto";
    import {GetProfilePictureOutput} from "../entities/GetProfilePictureOutput";
    import * as moment from 'moment';

    @Component
    export default class LoginAttempts extends AbpBase {
        @Prop({type: Boolean, default: false}) value: boolean;
        data: Array<UserLoginAttemptDto> = new Array<UserLoginAttemptDto>();
        profilePicture: string = null;

        getLoginAttemptTime(userLoginAttempt) {
            return (
                moment(userLoginAttempt.creationTime).fromNow() +
                ' (' +
                moment(userLoginAttempt.creationTime).format(
                    'YYYY-MM-DD hh:mm:ss'
                ) +
                ')'
            );
        };

        async getProfilePicture() {
            await this.$store.dispatch('profile/getProfilePicture').then(response => {
                const result: GetProfilePictureOutput = this.$store.state.profile.profilePictureOutput;
                if (result && result.profilePicture) {
                    this.profilePicture =
                        'data:image/jpeg;base64,' + result.profilePicture;
                }
            }).catch(reason => {
                this.$Notice.error({
                    title: '获取头像照片失败!',
                    desc: reason.response.statusText
                })
            })
        };

        async getRecentUserLoginAttempts() {
            await this.$store.dispatch('profile/getRecentUserLoginAttempts').then(response => {
                const userLoginAttemptDtos: Array<UserLoginAttemptDto> = this.$store.state.profile.userLoginAttemptDtos;
                if (userLoginAttemptDtos) {
                    this.data = userLoginAttemptDtos;
                }
            }).catch(reason => {
                this.$Notice.error({
                    title: '获取登录信息失败!',
                    desc: reason.response.statusText
                })
            })
        };

        cancel() {
            this.$emit('input', false);
        };

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.getRecentUserLoginAttempts();
                this.getProfilePicture();
            }
        };
    }
